<template>
	<v-card>
		<v-breadcrumbs :items="breadcrumbs" divider=">"></v-breadcrumbs>
		<div class="d-flex ml-4 mt-n2" style="width:618px;">
			<v-tabs background-color="deep-purple lighten-3" center-active v-model="tab" dark style="border-radius: 5px 5px 0 0;" active-class="child_active">
				<v-tabs-slider color="deep-purple darken-4"></v-tabs-slider>
				<v-tab>金额账户余额</v-tab>
				<v-tab>充值缴费订单</v-tab>
				<v-tab>手工扣费订单</v-tab>
				<v-tab>金额流水查询</v-tab>
				<v-tab>退费订单查询</v-tab>
			</v-tabs>
		</div>
		<v-tabs-items v-model="tab">
			<v-tab-item>
				<!-- 账户余额明细 -->
				<accountList></accountList>
			</v-tab-item>
			<v-tab-item>
				<!-- 订单查询 -->
				<cashRecharge></cashRecharge>
			</v-tab-item>
			<v-tab-item>
				<!-- 手工扣费订单 -->
				<cashReduceOrder></cashReduceOrder>
			</v-tab-item>
			<v-tab-item>
				<!-- 账户流水 -->
				<cashJournal></cashJournal>
			</v-tab-item>
			<v-tab-item>
				<!-- 退费订单 -->
				<cashRefundOrder></cashRefundOrder>
			</v-tab-item>
		</v-tabs-items>

	</v-card>
</template>

<script>
	import global from '../../../config/global'
	import accountList from "./student_cash_list.vue"
	import cashRecharge from "./cash_recharge_list.vue"
	import cashJournal from "./cash_journal_list.vue"
	import cashReduceOrder from "./cash_reduce_order.vue"
	import cashRefundOrder from "./cash_refund_order.vue"
	export default {
		name: "cash-account-index",
		components:{accountList,cashRecharge,cashJournal,cashReduceOrder,cashRefundOrder},
		data() {
			return {
				breadcrumbs: [{
						text: '首页',
						disabled: false,
						href: "/home/index"
					},
					{
						text: '财务中心',
						disabled: true
					},
					{
						text: '学员金额账户中心',
						disabled: true
					},
				],
				tab:null,
				
				
			}
		},
		created() {
		
		},
		
		methods: {
			
		}
	}
</script>

<style lang="scss" scoped>
	.child_active{
		background-color:#651FFF;
		border-radius: 5px 5px 0 0;	
	}
</style>
